import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Col, Row, Tooltip, Typography } from 'antd';
import { useState } from 'react';

import { ConfirmDeletingElement } from '@app/components';
import { Avatar } from '@app/components/Avatar';
import { NConfirmDeletingElement } from '@app/components/ConfirmDeletingElement/ConfirmDeletingElement.types';
import { TELEGRAM_COLOR } from '@app/constants/integrationsColors';
import { useNewUserAccessRights } from '@app/hooks';
import { privateFormatDate } from '@app/utils';

import { FakeDataComponent } from '@pages/Users/UserPreview/components/FakeDataComponent';

import type { NUserPreview } from '@pages/Users/UserPreview/UserPreview.types';

import type { IconProp } from '@fortawesome/fontawesome-svg-core';

const { Text } = Typography;

export const PersonalInfo: NUserPreview.PersonalInfo = ({
  user,
  restoreUser,
  isUnarchiveUserLoading,
}) => {
  const {
    userAccessRights: { IsAdmin: isAdminRights },
  } = useNewUserAccessRights();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  return (
    <div className="personal-info-container">
      <div className="photo-container">
        {user && (
          <Avatar
            src={user?.Photo}
            nameFirst={user?.NameFirst}
            nameLast={user?.NameLast}
            className="image"
            size={100}
          />
        )}
      </div>

      <div className="info-container">
        <Row className="item-container">
          <Col>
            <Text strong style={{ marginLeft: '6px' }} data-testid="full-name">
              {`${user?.NameLast ? user?.NameLast : ''} ${user?.NameFirst} `}
            </Text>
          </Col>

          <Col>
            {user?.IsDeleted ? (
              <Text
                style={{
                  backgroundColor: '#fa5656',
                  color: 'white',
                  padding: '5px 8px',
                  borderRadius: '5px',
                }}
              >
                В архиве
              </Text>
            ) : user?.IsTerminated ? (
              <Text
                style={{
                  backgroundColor: '#fa5656',
                  color: 'white',
                  padding: '5px 8px',
                  borderRadius: '5px',
                }}
              >
                Уволен
              </Text>
            ) : (
              ''
            )}
          </Col>
        </Row>

        {user?.IsAdmin && (
          <Row className="item-container">
            <Col>
              <FontAwesomeIcon
                icon={'fa-solid fa-circle-check' as IconProp}
                size={'lg'}
                style={{ width: '30px', color: '#1677ff' }}
              />
            </Col>

            <Col>
              <Text>Владелец</Text>
            </Col>
          </Row>
        )}

        {user?.Position && (
          <Row className="item-container">
            <Col>
              <FontAwesomeIcon
                icon={'fa-solid fa-briefcase' as IconProp}
                size={'lg'}
                style={{ width: '30px' }}
              />
            </Col>

            <Col>
              <Text>{user?.Position}</Text>
            </Col>
          </Row>
        )}

        <Row className="item-container">
          <Col>
            <FontAwesomeIcon
              icon={'fa-solid fa-phone' as IconProp}
              size={'lg'}
              style={{ width: '30px' }}
            />
          </Col>

          <Col>
            <Text data-testid="phone">
              {user?.IsFakePhone ? <FakeDataComponent /> : `+${user?.Phone}`}
            </Text>
          </Col>
        </Row>

        <Row className="item-container">
          <Col>
            <FontAwesomeIcon
              icon={'fa-regular fa-envelope' as IconProp}
              size={'lg'}
              style={{ width: '30px' }}
            />
          </Col>

          <Col>
            <Text data-testid="email">
              {user?.IsFakeEmail ? <FakeDataComponent /> : user?.Email}
            </Text>
          </Col>
        </Row>

        {user?.TelegramId && (
          <Row className="item-container">
            <Col>
              <FontAwesomeIcon
                icon={'fa-brands fa-telegram' as IconProp}
                size={'lg'}
                style={{ width: '30px', color: TELEGRAM_COLOR }}
              />
            </Col>

            <Col>
              <Text data-testid="telegram">{user.TelegramId}</Text>
            </Col>
          </Row>
        )}

        {user?.DateBirth && (
          <Row className="item-container">
            <Col>
              <FontAwesomeIcon
                icon={'fa-solid fa-cake-candles' as IconProp}
                size={'lg'}
                style={{ width: '30px' }}
              />
            </Col>

            <Col>
              <Text data-testid="date-of-birth">
                {privateFormatDate(user?.DateBirth.slice(5, 10))}
              </Text>
            </Col>
          </Row>
        )}
        {user?.IsDeleted && isAdminRights && (
          <Button
            type="primary"
            data-testid="restore-button"
            onClick={() => setIsDeleteModalOpen(true)}
            loading={isUnarchiveUserLoading}
          >
            <Tooltip title="Восстановить из архива">Восстановить</Tooltip>
          </Button>
        )}

        <ConfirmDeletingElement
          modalOpen={isDeleteModalOpen}
          setModalOpen={setIsDeleteModalOpen}
          handleDelete={() => user?.Id && restoreUser(user.Id)}
          content="Вы уверены, что хотите восстановить пользователя?"
          title="Восстановление пользователя"
          modalType={NConfirmDeletingElement.ModalType.Restore}
          okText="Восстановить"
        />
      </div>
    </div>
  );
};
